import { go, Model } from 'oderon-vue'
import { Vehicle } from './vehicle.js'
// import { ServiceBI } from './service-bis.js'

export const Client = new Model('/clients')

Client.findById = async (id) => {
  let client = await go.get(`/clients/${id}`)
  client.org = client.organization

  if (client.vehicleId != null) {
    client.vehicle = await Vehicle.findByOrgAndId(
      client.organizationId,
      client.vehicleId
    )
  } else {
    delete client.vehicle
  }

  // Descobre qual é o centro de custo atual deste módulo,
  // olhando o BillingItem mais recente que tenha serviceType
  // install ou remove.
  // let latestBIs = await ServiceBI.findAll({
  //   order: 'timestamp DESC, createdAt DESC',
  //   limit: 1,
  //   clientIds: client.id,
  //   serviceTypes: ['install', 'remove']
  // })

  // // Se o último registro é do tipo install, então guarda o
  // // costCenterId desse registro como sendo o "cost center atual"
  // // deste módulo. Observe que se o registro é uma retirada, não
  // // existe "cost center atual".
  // let latest = latestBIs.rows && latestBIs.rows[0]
  // if (latest != null && latest.serviceType == 'install') {
  //   client.currentCostCenterId = latest.costCenterId
  // } else {
  //   client.currentCostCenterId = null
  // }

  return client
}

Client.findMini = (ps) => go.get('/clients/mini', ps)
Client.setAssociation = (cid, body) =>
  go.post(`/clients/${cid}/operations/set-association`, body)

Client.patch = (cid, body) => go.patch(`/clients/${cid}`, body)
Client.saveOperation = (cid, type, body) => {
  if (cid == null || type == null) throw new Error('Missing cid or type')
  return go.post(`/clients/${cid}/operations/${type}`, body)
}
